module.exports = __webpack_public_path__ + "static/Trazado_unido-17fb1ed5520239ee970268ee9b20e96f.png";